import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import {
  HeaderWrapper,
  Logo,
  HamburgerMenu,
  NavContainer,
  NavLinks,
  Sticker,
} from "./Header.styled";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleNavClick = (e) => {
    closeMenu();
  };

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/");
    closeMenu();
  };

  const navItems = [
    { hash: "#photos", label: "Photos" },
    { hash: "#greetings", label: "Greetings" },
  ];

  return (
    <HeaderWrapper>
      <Logo
        src="/logo.png"
        alt="Company Logo"
        onClick={handleLogoClick}
        role="button"
        tabIndex={0}
        style={{ cursor: "pointer" }}
      />
      <HamburgerMenu
        onClick={toggleMenu}
        open={menuOpen}
        role="button"
        tabIndex={0}
      >
        <span></span>
        <span></span>
      </HamburgerMenu>
      <NavContainer open={menuOpen}>
        <NavLinks>
          {navItems.map((item, index) => (
            <li key={index}>
              <Link smooth to={item.hash} onClick={handleNavClick}>
                {item.label}
              </Link>
            </li>
          ))}
        </NavLinks>
        <Sticker>
          <img src="./sticker.png" alt="Sticker" />
        </Sticker>
      </NavContainer>
    </HeaderWrapper>
  );
};

export default Header;
